(function ($) {
  'use strict';

  /*
   * PWR Core is optional.
   * Header should still work if Core hasn't loaded yet.
   */

  var PWR = window.PWR || {};
  var utils = PWR.utils || {};
  var Section = PWR.Section || null;
  var SCROLL_LOCK = PWR.scrollLock || null;


  /* ===============================================================
     HEADER
     =============================================================== */

  function Header(root) {

    this.root = root;
    this.$root = $(root);

    this.$drawer = $();
    this.$drawerToggle = $();
    this.$drawerClose = $();
    this.$overlay = $();

    this.$searchToggle = $();
    this.$searchPanel = $();
    this.$searchClose = $();

    this._releaseFocus = null;

    this.init();
  }


  /* ===============================================================
     INIT
     =============================================================== */

  Header.prototype.init = function () {

    this.$drawer =
      this.$root.find('[data-pwr-header-drawer]');

    this.$drawerToggle =
      this.$root.find('[data-pwr-drawer-toggle]');

    this.$drawerClose =
      this.$root.find('[data-pwr-drawer-close]');

    this.$overlay =
      $('[data-pwr-header-overlay]');


    this.$searchToggle =
      this.$root.find('[data-pwr-search-toggle]');

    this.$searchPanel =
      this.$root.find('[data-pwr-search-panel]');

    this.$searchClose.on(
  'click.pwrHeader',
  function (event) {
    event.preventDefault();
    self.closeSearch();
  }
);


    this._bindDrawer();
    this._bindMegaMenu();
    this._bindSearch();
    this._bindKeyboard();
    this._bindStickyFallback();


    console.log('PWR Header initialized', {
      drawer: this.$drawer.length,
      search: this.$searchPanel.length,
      core: !!window.PWR
    });
  };


  /* ===============================================================
     DRAWER
     =============================================================== */

  Header.prototype._bindDrawer = function () {

    var self = this;

    this.$drawerToggle.on(
      'click.pwrHeader',
      function (event) {

        event.preventDefault();

        if (
          self.$drawer.hasClass('is-open')
        ) {
          self.closeDrawer();
        } else {
          self.openDrawer();
        }
      }
    );


    this.$drawerClose.on(
      'click.pwrHeader',
      function (event) {

        event.preventDefault();

        self.closeDrawer();
      }
    );


    this.$overlay.on(
      'click.pwrHeader',
      function () {

        self.closeDrawer();
        self.closeSearch();
      }
    );


    this.$root
      .find('[data-pwr-submenu-toggle]')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();

          var $button = $(this);

          var expanded =
            $button.attr('aria-expanded') === 'true';

          var submenuId =
            $button.attr('aria-controls');

          var $panel =
            $('#' + submenuId);


          $button.attr(
            'aria-expanded',
            expanded ? 'false' : 'true'
          );


          if (!$panel.length) {
            return;
          }


          if (expanded) {

            $panel
              .stop(true, true)
              .slideUp(220, function () {

                $panel.attr('hidden', true);

              });

          } else {

            $panel.removeAttr('hidden');

            $panel
              .hide()
              .stop(true, true)
              .slideDown(220);

          }
        }
      );
  };


  /* ===============================================================
     OPEN DRAWER
     =============================================================== */

  Header.prototype.openDrawer = function () {

    if (!this.$drawer.length) {
      return;
    }


    this.closeSearch();


    this.$drawer.addClass('is-open');

    this.$drawer.removeAttr('inert');

    this.$drawerToggle.attr(
      'aria-expanded',
      'true'
    );

    this.$overlay.addClass(
      'is-visible'
    );


    if (
      SCROLL_LOCK &&
      typeof SCROLL_LOCK.lock === 'function'
    ) {

      SCROLL_LOCK.lock();

    } else {

      document.documentElement.classList.add(
        'pwr-menu-open'
      );

      document.body.classList.add(
        'pwr-menu-open'
      );

    }
  };


  /* ===============================================================
     CLOSE DRAWER
     =============================================================== */

  Header.prototype.closeDrawer = function () {

    if (!this.$drawer.length) {
      return;
    }


    this.$drawer.removeClass(
      'is-open'
    );

    this.$drawer.attr(
      'inert',
      ''
    );

    this.$drawerToggle.attr(
      'aria-expanded',
      'false'
    );


    if (!this._searchOpen()) {

      this.$overlay.removeClass(
        'is-visible'
      );

    }


    if (
      SCROLL_LOCK &&
      typeof SCROLL_LOCK.unlock === 'function'
    ) {

      SCROLL_LOCK.unlock();

    } else {

      document.documentElement.classList.remove(
        'pwr-menu-open'
      );

      document.body.classList.remove(
        'pwr-menu-open'
      );

    }
  };


  /* ===============================================================
     SEARCH
     =============================================================== */

  Header.prototype._bindSearch = function () {

    var self = this;


    this.$searchToggle.on(
      'click.pwrHeader',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        if (self._searchOpen()) {

          self.closeSearch();

        } else {

          self.openSearch();

        }
      }
    );


    this.$searchClose.on(
      'click.pwrHeader',
      function (event) {

        event.preventDefault();

        self.closeSearch();

      }
    );
  };


  Header.prototype._searchOpen = function () {

    return (
      this.$searchPanel.length &&
      this.$searchPanel.hasClass('is-open')
    );
  };


  /* ===============================================================
     OPEN SEARCH
     =============================================================== */

  Header.prototype.openSearch = function () {

  if (!this.$searchPanel.length) {
    return;
  }


  /*
   * Close mobile drawer.
   */
  this.closeDrawer();


  /*
   * Open PWR search panel.
   */
  this.$searchPanel
    .removeAttr('inert')
    .addClass('is-open');


  /*
   * Find Dawn details-modal.
   */
  var $details =
    this.$searchPanel
      .find('details-modal > details')
      .first();


  /*
   * Open Dawn details.
   */
  if ($details.length) {

    $details.prop(
      'open',
      true
    );

  }


  /*
   * Overlay.
   */
  this.$overlay.addClass(
    'is-visible'
  );


  /*
   * Accessibility.
   */
  this.$searchToggle.attr(
    'aria-expanded',
    'true'
  );


  /*
   * Focus actual input.
   */
  var $input =
    this.$searchPanel
      .find('input[type="search"]')
      .first();


  if ($input.length) {

    window.requestAnimationFrame(
      function () {

        $input.trigger('focus');

      }
    );

  }
};

  /* ===============================================================
     CLOSE SEARCH
     =============================================================== */

  Header.prototype.closeSearch = function () {

  if (!this.$searchPanel.length) {
    return;
  }


  /*
   * Close Dawn details.
   */
  var $details =
    this.$searchPanel
      .find('details-modal > details')
      .first();


  if ($details.length) {

    $details.prop(
      'open',
      false
    );

  }


  /*
   * Close PWR panel.
   */
  this.$searchPanel
    .removeClass('is-open')
    .attr('inert', '');


  /*
   * Accessibility.
   */
  this.$searchToggle.attr(
    'aria-expanded',
    'false'
  );


  /*
   * Hide overlay if drawer isn't open.
   */
  if (
    !this.$drawer.hasClass('is-open')
  ) {

    this.$overlay.removeClass(
      'is-visible'
    );

  }
};


  /* ===============================================================
     MEGA MENU
     =============================================================== */

  Header.prototype._bindMegaMenu = function () {

    var self = this;

    var supportsHover =
      window.matchMedia &&
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;


    if (!supportsHover) {
      return;
    }


    this.$root
      .find('[data-pwr-mega]')
      .each(function () {

        var $details = $(this);

        var closeTimer;


        $details.on(
          'mouseenter.pwrHeader',
          function () {

            clearTimeout(closeTimer);


            self.$root
              .find('[data-pwr-mega]')
              .not($details)
              .prop('open', false);


            $details.prop(
              'open',
              true
            );
          }
        );


        $details.on(
          'mouseleave.pwrHeader',
          function () {

            closeTimer =
              setTimeout(function () {

                $details.prop(
                  'open',
                  false
                );

              }, 150);
          }
        );

      });
  };


  /* ===============================================================
     KEYBOARD
     =============================================================== */

  Header.prototype._bindKeyboard = function () {

    var self = this;


    $(document).on(
      'keydown.pwrHeader',
      function (event) {

        if (event.key !== 'Escape') {
          return;
        }


        if (self._searchOpen()) {

          self.closeSearch();

          return;
        }


        if (
          self.$drawer.hasClass('is-open')
        ) {

          self.closeDrawer();

          return;
        }


        self.$root
          .find('[data-pwr-mega]')
          .prop('open', false);

      }
    );
  };


  /* ===============================================================
     STICKY FALLBACK
     =============================================================== */

  Header.prototype._bindStickyFallback = function () {

    var self = this;

    var $header =
      this.$root.find('[data-section-type="pwr-header"]');


    if (!$header.length) {
      return;
    }


    /*
     * Only use fallback when PWR Core isn't available.
     */

    if (
      window.PWR &&
      window.PWR.registerSection
    ) {
      return;
    }


    var lastScroll = window.scrollY;


    $(window).on(
      'scroll.pwrHeaderFallback',
      function () {

        var currentScroll =
          window.scrollY;


        if (currentScroll > 80) {

          $header.addClass(
            'is-condensed'
          );

        } else {

          $header.removeClass(
            'is-condensed'
          );

        }


        if (
          currentScroll > lastScroll &&
          currentScroll > 180
        ) {

          $header.addClass(
            'is-hidden'
          );

        } else {

          $header.removeClass(
            'is-hidden'
          );

        }


        lastScroll = currentScroll;

      }
    );
  };


  /* ===============================================================
     INITIALIZE
     =============================================================== */

  function initPWRHeader() {

    $('[data-section-type="pwr-header"]')
      .each(function () {

        /*
         * Prevent duplicate initialization.
         */

        if (
          this.__pwrHeaderInitialized
        ) {
          return;
        }


        this.__pwrHeaderInitialized = true;


        new Header(
          this.parentElement
        );

      });
  }


  /* ===============================================================
     START
     =============================================================== */

  $(function () {

    initPWRHeader();

  });


})(jQuery);